import { render, staticRenderFns } from "./Super.vue?vue&type=template&id=882992d0&scoped=true&"
import script from "./Super.vue?vue&type=script&lang=js&"
export * from "./Super.vue?vue&type=script&lang=js&"
import style0 from "./Super.vue?vue&type=style&index=0&id=882992d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882992d0",
  null
  
)

export default component.exports